import axios, { AxiosError } from "axios"

export interface HandleErrorOptions {
  http: (error: AxiosError, placeholder?: string) => Promise<string>,
  unknown: (error: unknown, placeholder?: string) => Promise<string>,
  placeholder?: string

}

export const getErrorMessage = (attempt?: unknown, placeholder?: string) => {
  if(typeof attempt !== "string" && (!Array.isArray(attempt) || attempt.every(e => typeof e !== "string"))) {
    return placeholder || "An error occurred, please try again."
  }

  return Array.isArray(attempt) ? attempt.filter(e => typeof e === "string").join("\n") : attempt
}

export const handleError = (error: unknown, options: Partial<HandleErrorOptions> = {}) => {
  const o: HandleErrorOptions = {
    http: async (e: AxiosError, placeholder) => getErrorMessage(e.response?.data?.errors, placeholder),
    unknown: async (e: unknown, placeholder) => getErrorMessage(null, placeholder),
    ...options
  }
  
  return axios.isAxiosError(error) ? o.http(error, o.placeholder) : o.unknown(error, o.placeholder)
}
